import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import 'slick-carousel';
import 'magnific-popup';

export default {
    links() {
        /** SKIP LINK NAVIGATION */
        $('#skip-to-content').click(function () {
            // strip the leading hash and declare
            // the content we're skipping to
            var skipTo = '#' + this.href.split('#')[1];
            // Setting 'tabindex' to -1 takes an element out of normal
            // tab flow but allows it to be focused via javascript
            $(skipTo)
                .attr('tabindex', -1)
                .on('blur focusout', function () {
                    // when focus leaves this element,
                    // remove the tabindex attribute
                    $(this).removeAttr('tabindex');
                })
                .focus(); // focus on the content container
        });
        /** END SKIP LINK NAVIGATION */

        /** ANIMATED ANCHOR LINKS **/
        $('a[href*="#"]:not([href="#"])').click(function (e) {
            // Doesn't do it on page builder tabs
            if (!$(this).closest('li').hasClass('vc_tta-tab')) {
                if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                    if (
                        location.pathname.replace(/^\//, '') ===
                            this.pathname.replace(/^\//, '') &&
                        location.hostname === this.hostname
                    ) {
                        var target = $(this.hash);
                        var $this = this;
                        var header = $('header.header');
                        var wpAdminBar = $('#wpadminbar');
                        var fixedHeaderOffset =
                            parseInt(header.outerHeight()) -
                            parseInt(
                                header.css('padding-top').replace('px', '')
                            );
                        // If we're logged in and WP ADmin Bar exists, add it to the offset
                        if (wpAdminBar.length) {
                            fixedHeaderOffset += parseInt(
                                wpAdminBar.outerHeight()
                            );
                        }
                        target = target.length
                            ? target
                            : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html,body').animate(
                                {
                                    scrollTop:
                                        target.offset().top - fixedHeaderOffset,
                                },
                                500,
                                function () {
                                    if (history.pushState) {
                                        history.pushState(
                                            null,
                                            null,
                                            $this.hash
                                        );
                                    } else {
                                        location.hash = $this.hash;
                                    }
                                }
                            );
                            e.preventDefault();
                        }
                    }
                }
            }
        });
        /** END ANIMATED ANCHOR LINKS **/

        /** Break link text to new line when link text is a URL **/
        $(document).ready(function () {
            $('a').each(function () {
                var $this = $(this);
                var innerLink = $this.text();
                if (innerLink.startsWith('http')) {
                    $this.css('word-break', 'break-all');
                }
            });
        });
        /** End Break link text to new line when link text is a URL **/
    },
    itemReveal() {
        // eslint-disable-next-line no-unused-vars
        // var $itemReveals = $('.reveal').waypoint({
        //   handler: function () {
        //     $(this)[0].element.classList.add('revealed');
        //   },
        //   offset: '85%',
        // });

        // Use gsap and ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);
        let reveals = gsap.utils.toArray('.image-reveal');
        reveals.forEach((reveal) => {
            ScrollTrigger.create({
                trigger: reveal,
                start: 'top 75%', // when the top of the element is 75% from the top of the viewport
                toggleClass: 'revealed',
                // toggleActions: 'play pause resume none',
                once: true, // only trigger the toggle once. we can control repeat behavior using toggleActions
            });
        });

        // Stagger reveals with a gsap.timeline() + ScrollTrigger
        let staggers = gsap.utils.toArray('.reveal--staggered');
        staggers.forEach((stagger) => {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: stagger,
                    start: 'top 75%',
                },
            });

            let children = stagger.children; // the immediate children elements of the current target

            tl.to(children, {
                duration: 1,
                y: 0,
                opacity: 1,
                stagger: 0.15,
            });
        });
    },
    slider() {
        let visceralSlider = $('.visceral-slider');

        if (visceralSlider) {
            visceralSlider.each(function () {
                console.log($(this));
                let slider, slide, slidesToShow, centerMode;
                slider = $(this).find(
                    '> .wpb_column > .vc_column-inner > .wpb_wrapper'
                );
                slide =
                    '.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper > *';

                slidesToShow = 1;
                centerMode = true;

                if ($(this).hasClass('posts-list-container')) {
                    slider = $('.visceral-slider .row');
                    slide = '.visceral-slider .row > *';
                    slidesToShow = visceralSlider.attr('data-slides-to-show');
                    centerMode = false;
                }

                slider.slick({
                    slide: slide,
                    autoplay: false,
                    fade: false,
                    speed: 1200,
                    infinite: true,
                    cssEase: 'ease',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: true,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow:
                        '<button type="button" class="slick-next btn--no-decoration"><span class="screen-reader-text">Next</span><i class="icon-chevron-right"></i></button>',
                    prevArrow:
                        '<button type="button" class="slick-prev btn--no-decoration"><span class="screen-reader-text">Previous</span><i class="icon-chevron-left"></i></button>',
                    responsive: [
                        {
                            breakpoint: 560, // min-width
                            settings: {
                                slidesToShow: 2,
                                centerMode: centerMode,
                            },
                        },
                        {
                            breakpoint: 992, // min-width
                            settings: {
                                slidesToShow: slidesToShow,
                            },
                        },
                    ],
                });
            });
        }

        let featuredSlider = $('.visc-featured-slider__images');

        if (featuredSlider) {
            featuredSlider.slick({
                autoplay: true,
                fade: true,
                speed: 1000,
                autoplaySpeed: 5000,
                infinite: true,
                cssEase: 'ease',
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                dots: false,
                arrows: false,
                mobileFirst: true,
                pauseOnFocus: false,
                pauseOnHover: false,
            });

            let $slideControls = $('.visc-featured-slider__item-content');

            $slideControls
                .first()
                .addClass('visc-featured-slider__item-content--active');
            $slideControls.each(function () {
                let $this = $(this);
                let index = $this.data('index');

                // On a control click
                $this.on('mouseover', function () {
                    // Remove all current-control classes and add it to clicked control
                    $slideControls.removeClass(
                        'visc-featured-slider__item-content--active'
                    );
                    $(this).addClass(
                        'visc-featured-slider__item-content--active'
                    );

                    // Hook into Slick's method to go to corresponding slide
                    featuredSlider.slick('slickGoTo', index, false);
                });
            });

            featuredSlider.on(
                'beforeChange',
                function (event, slick, currentSlide, nextSlide) {
                    // Remove all current-control classes and add it to clicked control
                    $slideControls.removeClass(
                        'visc-featured-slider__item-content--active'
                    );
                    $(
                        '.visc-featured-slider__item-content[data-index="' +
                            nextSlide +
                            '"]'
                    ).addClass('visc-featured-slider__item-content--active');
                }
            );
        }
        let featuredGranteesList = $('.ge_featured-grants-list');
        let slidesToShow = 3;
        let $progressBar;
        if (featuredGranteesList) {
            let featuredGranteesSlider = $('.ge_featured-grants-list .ge_row');
            let featuredGranteesSlides = $(
                '.ge_featured-grants-list .ge_row > *'
            );
            featuredGranteesList.append(
                '<div class="progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"><span class="slider__label sr-only"></div>'
            );
            if (featuredGranteesSlides.length > slidesToShow) {
                $progressBar = $('.ge_featured-grants-list .progress');
            }
            if (featuredGranteesSlider) {
                featuredGranteesSlider.slick({
                    slide: '.ge_featured-grants-list .ge_row > *',
                    autoplay: false,
                    fade: false,
                    speed: 600,
                    infinite: false,
                    cssEase: 'ease',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    rows: 0,
                    nextArrow: `<button type="button" class="slick-next btn--no-decoration"><span class="screen-reader-text">Next</span><svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M-1.39144e-06 11.307L18.9924 11.307L12.1221 18.1763L13.9542 20L24 10L13.9542 2.521e-06L12.1221 1.82371L18.9924 8.69301L-1.23631e-06 8.69301L-1.39144e-06 11.307Z" fill="#CCCCCC"/>
                        </svg>
                        </button>`,
                    prevArrow: `<button type="button" class="slick-prev btn--no-decoration"><span class="screen-reader-text">Previous</span><svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24 8.69301L5.00763 8.69301L11.8779 1.82371L10.0458 2.17193e-06L-1.4677e-06 10L10.0458 20L11.8779 18.1763L5.00763 11.307L24 11.307L24 8.69301Z" fill="#CCCCCC"/>
                        </svg>
                        </i></button>`,
                    responsive: [
                        {
                            breakpoint: 768, // min-width
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                        {
                            breakpoint: 992, // min-width
                            settings: {
                                slidesToShow: slidesToShow,
                            },
                        },
                    ],
                });

                // progress bar
                if ($progressBar) {
                    let slides;
                    let viewportSmall = window.innerWidth;
                    if (viewportSmall < 768) {
                        slides = 1;
                    } else if (viewportSmall < 992) {
                        slides = 2;
                    } else {
                        slides = 3;
                    }
                    featuredGranteesSlider.on(
                        'beforeChange',
                        function (event, slick, currentSlide, nextSlide) {
                            var calc =
                                (nextSlide / (slick.slideCount - slides)) * 100;
                            let progressBarWidth = calc;
                            if (0 === calc) {
                                progressBarWidth = 10;
                            }
                            $progressBar
                                .css(
                                    'background-size',
                                    progressBarWidth + '% 100%'
                                )
                                .attr('aria-valuenow', calc);
                        }
                    );
                }
            }
        }
    },
    magnificPopup() {
        let videoLink = $('.modal-link-video');
        if (videoLink) {
            videoLink.magnificPopup({
                disableOn: 700,
                type: 'iframe',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
            });
        }
    },
    masthead() {
        /** MASTHEAD PRGRESSIVE IMAGES **/
        var masthead = document.querySelector('.masthead'),
            placeholderOverlay = document.querySelector('.masthead__overlay');

        if (masthead && placeholderOverlay) {
            // Load full size image. When loaded, fade our placeholder add it as bg to masthead
            var img = new Image();
            img.src = masthead.dataset.imageSrc;
            img.onload = function () {
                placeholderOverlay.classList.add('fade-out');
                masthead.style.backgroundImage = 'url(' + img.src + ')';
            };
        }
        /** END MASTHEAD PRGRESSIVE IMAGES **/
    },
    header() {
        /** FIXED HEADER ANIMATION **/
        let didScroll = false,
            scrollOffset = 100,
            lastScroll = 0;

        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }

        function scrollPage() {
            var currentScroll = scrollY();
            if (currentScroll > scrollOffset) {
                $('.site-header--fixed').addClass(
                    'site-header--scroll-triggered'
                );
            } else {
                $('.site-header--fixed').removeClass(
                    'site-header--scroll-triggered'
                );
            }
            didScroll = false;
            if (currentScroll > scrollOffset) {
                if (
                    currentScroll > lastScroll &&
                    !$('.site-header--fixed').hasClass(
                        'site-header--scroll-down'
                    )
                ) {
                    // scrolling down
                    $('.site-header--fixed').removeClass(
                        'site-header--scroll-up'
                    );
                    $('.site-header--fixed').addClass(
                        'site-header--scroll-down'
                    );
                } else if (
                    currentScroll < lastScroll &&
                    $('.site-header--fixed').hasClass(
                        'site-header--scroll-down'
                    )
                ) {
                    // scrolling up
                    $('.site-header--fixed').removeClass(
                        'site-header--scroll-down'
                    );
                    $('.site-header--fixed').addClass('site-header--scroll-up');
                }
                lastScroll = currentScroll;
            } else {
                $('.site-header--fixed').removeClass(
                    'site-header--scroll-down'
                );
                $('.site-header--fixed').removeClass('site-header--scroll-up');
            }
        }

        window.addEventListener('load', scrollPage);
        window.addEventListener(
            'scroll',
            function () {
                // eslint-disable-line no-unused-vars
                if (!didScroll) {
                    didScroll = true;
                    setTimeout(scrollPage, 100);
                }
            },
            false
        );
        /** END FIXED HEADER ANIMATION **/

        /**  SEARCH OVERLAY **/
        const siteHeader = document.querySelector('.site-header');
        const searchIcon = document.querySelector('.site-header__search-icon');
        const siteSearch = document.querySelector('.site-search');
        const siteSearchClose = document.querySelector(
            '.site-header__search-icon-close'
        );
        if (searchIcon) {
            searchIcon.addEventListener('click', (e) => {
                e.preventDefault();
                siteSearch.classList.add('site-search--active');
                siteHeader.classList.add('site-header--search-active');
                setTimeout(() => {
                    $('.site-search__form input[type="text"]').focus();
                }, 500);
            });
        }
        if (siteSearchClose) {
            siteSearchClose.addEventListener('click', () => {
                siteSearch.classList.remove('site-search--active');
                siteHeader.classList.remove('site-header--search-active');
            });
        }
        /**  END SEARCH OVERLAY **/

        // Mobile Icon
        $('.mobile-nav-icon').on('click', function () {
            $(this).toggleClass('mobile-nav-icon--active');
            $('.site-header').toggleClass('site-header--mobile-nav-active');
            $('body').toggleClass('mobile-nav-active');
        });

        // Disable click on mobile
        $('.mobile-menu__item--parent .mobile-menu__sub-menu-toggle').on(
            'click',
            function () {
                $(this).parent('.mobile-menu__item').find('ul').slideToggle();
                $(this)
                    .parent('.mobile-menu__item')
                    .toggleClass('mobile-menu__item--opened')
                    .find('ul')
                    .slideToggle();
            }
        );
    },
    mainNavAccessibility() {
        let $mainNavigationTopLevelItemLinks = $(
            '.site-header .main-menu > .main-menu__item--parent > button'
        );

        if ($mainNavigationTopLevelItemLinks.length) {
            $mainNavigationTopLevelItemLinks.each(function () {
                $(this).prev('a').attr('aria-haspopup', 'true');
                $(this).on('click', function () {
                    $(this).closest('li').toggleClass('sub-menu-open');
                    $(this).attr('aria-expanded', 'true');
                });
            });
        }
    },
    ajaxLoadMore() {
        // AJAX Load More
        function visc_load_more() {
            // eslint-disable-next-line no-undef
            if (visceral_vars !== undefined) {
                var data = {
                    action: 'visc_load_more',
                    // eslint-disable-next-line no-undef
                    query: visceral_vars.query,
                    // eslint-disable-next-line no-undef
                    paged: visceral_vars.current_page,
                    // eslint-disable-next-line no-undef
                    security: visceral_vars.security,
                };

                var $button = $('.btn--load-more');

                $.ajax({
                    // eslint-disable-next-line no-undef
                    url: visceral_vars.ajaxurl, // AJAX handler
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        $button.find('span').text('Loading...'); // change the button text, you can also add a preloader image
                    },
                    complete: function () {
                        this.itemReveal();
                    },
                    success: function (data) {
                        $button.blur();
                        if (data) {
                            $button.find('span').text('Load More');

                            var $postsContainer = $(
                                '.posts-list-container > div'
                            );
                            $postsContainer.append(data);
                            // eslint-disable-next-line no-undef
                            visceral_vars.current_page++;
                            // eslint-disable-next-line no-undef
                            if (
                                // eslint-disable-next-line no-undef
                                visceral_vars.current_page ==
                                // eslint-disable-next-line no-undef
                                visceral_vars.max_page
                            ) {
                                $button.remove(); // if last page, remove the button
                            }
                        } else {
                            $button.remove(); // if last page, remove the button
                        }
                    },
                });
            }
        }

        $('.btn--load-more').on('click', function () {
            visc_load_more();
        });
    },
    socialShare() {
        /**  SOCIAL SHARE OVERLAY **/
        const shareLink = document.querySelector('.visc-social-share-btn');
        const socialShare = document.querySelector('.visc-social-share');
        const socialShareInner = document.querySelector(
            '.visc-social-share__inner'
        );
        const socialShareClose = document.querySelector(
            '.visc-social-share__close'
        );

        if (socialShare) {
            shareLink.addEventListener('click', () => {
                if (navigator.share) {
                    navigator.share({
                        title: document.title,
                        url: window.location.href,
                    });
                } else {
                    socialShare.classList.add('visc-social-share--active');
                }
                // console.log(shareLink);
            });
            socialShareClose.addEventListener('click', () => {
                socialShare.classList.remove('visc-social-share--active');
            });

            socialShareInner.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            socialShare.addEventListener('click', () => {
                socialShare.classList.remove('visc-social-share--active');
            });
        }
        /**  END SOCIAL SHARE OVERLAY **/
    },
    init() {
        // JavaScript to be fired on all pages

        /** GLOBAL VARIABLES */
        // var body = document.querySelector('body');
        /** END GLOBAL VARIABLES */

        // Blockquote decorations
        let $blockquotes = $('blockquote');
        if ($blockquotes.length) {
            $blockquotes.each(function () {
                $(this).prepend(
                    `<svg class="blockquote__start-quote" width="115" height="92" viewBox="0 0 115 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24 41C24 37.6604 25.7935 33.6851 30.5833 30.1235C35.3729 26.5619 42.5519 24 51 24V0C37.909 0 25.588 3.92996 16.2624 10.8644C6.93698 17.7986 0 28.3234 0 41V92H51V41H24Z" fill="white"/>
                        <path d="M88 41C88 37.6604 89.7935 33.6851 94.5833 30.1235C99.3729 26.5619 106.552 24 115 24V0C101.909 0 89.588 3.92996 80.2624 10.8644C70.937 17.7986 64 28.3234 64 41V92H115V41H88Z" fill="white"/>
                        </svg>`
                );

                $(this).prepend(
                    `<svg class="blockquote__end-quote" width="115" height="92" viewBox="0 0 115 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M91 51C91 54.3396 89.2065 58.3149 84.4167 61.8765C79.6271 65.4381 72.4481 68 64 68L64 92C77.091 92 89.412 88.07 98.7376 81.1356C108.063 74.2014 115 63.6766 115 51L115 0L64 -4.45856e-06L64 51L91 51Z" fill="white"/>
                    <path d="M27 51C27 54.3396 25.2065 58.3149 20.4167 61.8765C15.6271 65.4381 8.44811 68 2.09815e-06 68L0 92C13.091 92 25.412 88.07 34.7376 81.1356C44.063 74.2014 51 63.6766 51 51L51 0L8.0429e-06 -4.45856e-06L3.58433e-06 51L27 51Z" fill="white"/>
                    </svg>
                    `
                );
            });
        }

        function buttonDecoration() {
            // Button decorations
            let $buttons = $(
                'button, input[type="button"], input[type="submit"], input[type="reset"], .btn'
            );
            if ($buttons.length) {
                $buttons.each(function () {
                    if (
                        !$(this).hasClass('btn--no-decoration') &&
                        !$(this).hasClass('btn--decorated')
                    ) {
                        $(this).addClass('btn--decorated');
                        $(this).wrapInner('<span></span>');
                        if ($(this).hasClass('visc-social-share-btn')) {
                            $(this).prepend(
                                `<svg class="btn__icon" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.6667 15.5553C16.25 15.5553 15.855 15.6329 15.4818 15.7882C15.1085 15.9435 14.7743 16.1506 14.4792 16.4094L6.5625 11.8282C6.59722 11.7074 6.62326 11.5824 6.64062 11.4529C6.65799 11.3235 6.66667 11.1898 6.66667 11.0518C6.66667 10.9137 6.65799 10.78 6.64062 10.6506C6.62326 10.5212 6.59722 10.3961 6.5625 10.2753L14.401 5.74588C14.6962 6.02196 15.0391 6.23765 15.4297 6.39294C15.8203 6.54824 16.2326 6.62588 16.6667 6.62588C17.5868 6.62588 18.3724 6.30236 19.0234 5.65529C19.6745 5.00823 20 4.22746 20 3.31294C20 2.39843 19.6745 1.61765 19.0234 0.970588C18.3724 0.323527 17.5868 0 16.6667 0C15.7465 0 14.9609 0.323527 14.3099 0.970588C13.6589 1.61765 13.3333 2.39843 13.3333 3.31294C13.3333 3.45098 13.342 3.58471 13.3594 3.71412C13.3767 3.84353 13.4028 3.96863 13.4375 4.08941L5.59896 8.64471C5.30382 8.36863 4.96094 8.14863 4.57031 7.98471C4.17969 7.82078 3.76736 7.73882 3.33333 7.73882C2.41319 7.73882 1.62761 8.06235 0.976562 8.70941C0.325518 9.35647 0 10.1372 0 11.0518C0 11.9663 0.325518 12.7471 0.976562 13.3941C1.62761 14.0412 2.41319 14.3647 3.33333 14.3647C3.76736 14.3647 4.17969 14.2871 4.57031 14.1318C4.96094 13.9765 5.30382 13.7608 5.59896 13.4847L13.5156 18.0659C13.4809 18.1867 13.4592 18.3075 13.4505 18.4282C13.4418 18.549 13.4375 18.6698 13.4375 18.7906C13.4375 19.6706 13.75 20.4255 14.375 21.0553C15 21.6851 15.7639 22 16.6667 22C17.5695 22 18.3333 21.6851 18.9583 21.0553C19.5833 20.4255 19.8958 19.6706 19.8958 18.7906C19.8958 17.8933 19.5833 17.1298 18.9583 16.5C18.3333 15.8702 17.5695 15.5553 16.6667 15.5553Z" fill="white"/>
                                </svg>
                                `
                            );
                        } else {
                            $(this).prepend(
                                `<svg class="btn__icon" width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M-1.39144e-06 11.307L18.9924 11.307L12.1221 18.1763L13.9542 20L24 10L13.9542 2.521e-06L12.1221 1.82371L18.9924 8.69301L-1.23631e-06 8.69301L-1.39144e-06 11.307Z" fill="#081F41"/>
                                </svg>`
                            );
                        }
                    }
                });
            }
        }

        buttonDecoration();

        $(document).on('grantsExplorer:ajaxSuccess', function () {
            buttonDecoration();
        });

        let $formClear = $('.ge_grants-form__clear');
        if ($formClear.length) {
            $formClear.each(function () {
                if (
                    !$(this).hasClass('btn--no-decoration') &&
                    !$(this).hasClass('btn--decorated')
                ) {
                    $(this).addClass('btn');
                    $(this).addClass('btn--decorated');
                    $(this).wrapInner('<span></span>');
                    $(this).prepend(
                        `<svg class="btn__icon" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 1.91275L11.4128 9.5L19 17.0872L17.0872 19L9.5 11.4128L1.91275 19L0 17.0872L7.58725 9.5L0 1.91275L1.91275 0L9.5 7.58725L17.0872 0L19 1.91275Z" fill="white"/>
                        </svg>`
                    );
                }
            });
        }

        // Misc. link behaviors
        this.links();

        // Global reveal animations (consider commenting out this and 'gsap' and 'ScrollTrigger' import if not in use)
        this.itemReveal();

        // Slider (consider commenting out this and 'slick-carousel' import if not in use)
        this.slider();

        // Modals (consider commenting out this and 'magnific-popup' import if not in use)
        this.magnificPopup();

        // Masthead
        this.masthead();

        // Header
        this.header();

        // Main Nav Accessibility
        this.mainNavAccessibility();

        // Load more
        this.ajaxLoadMore();

        // Social share
        this.socialShare();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js